import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import type { TextRecommendationFragment } from '@/features/why-to-watch/graphql/fragments/TextRecommendation.fragment';
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import TextRecommendationCardTitleDetailProfile from '@/features/why-to-watch/components/TextRecommendationCardTitleDetailProfile.vue';

import { SnowplowContext } from '@/helpers/tracking/providers';
import { faCheck, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendationCardTitleDetailModal',
  props: {
    textRecommendation: null,
    title: null,
    additionalContexts: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'close', display: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	textRecommendation: TextRecommendationFragment;
	title: TitleDetail;
	additionalContexts?: SnowplowContext[];
};

const BaseModalNew = () => import('@/components/modals/BaseModalNew.vue');





const showOriginalText = ref<boolean>(false);

const profile = computed(() => props.textRecommendation.profile);

const headline = computed(() => props.textRecommendation.headline);
const originalHeadline = computed(() => props.textRecommendation.originalHeadline);
const bodyHTML = computed(() => props.textRecommendation.bodyHTML);
const originalBodyHTML = computed(() => props.textRecommendation.originalBodyHTML);

const titleName = computed(() => {
	return props.title?.content.title;
});

const displayedHeadline = computed(() => {
	if (showOriginalText.value && originalHeadline.value) return originalHeadline.value;
	return headline.value;
});

const displayedBodyHTML = computed(() => {
	if (showOriginalText.value && originalBodyHTML.value) return originalBodyHTML.value;
	return bodyHTML.value;
});

const showWatchedAt = computed(() => {
	return ['JW_EDITOR', 'USER', 'PRO_USER'].includes(props.textRecommendation.profile.profileType);
});

const dateWatched = computed(() => {
	return Intl.DateTimeFormat('en-GB', {
		day: '2-digit',
		month: 'long',
		year: 'numeric',
	}).format(new Date(props.textRecommendation.watchedAt));
});

return { __sfc: true,BaseModalNew, props, emits, showOriginalText, profile, headline, originalHeadline, bodyHTML, originalBodyHTML, titleName, displayedHeadline, displayedBodyHTML, showWatchedAt, dateWatched, TextRecommendationCardTitleDetailProfile, faCheck, faThumbsUp, faThumbsDown }
}

})